import { SpacingType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLElement>["className"];
  id?: HTMLAttributes<HTMLElement>["id"];
  gap?: SpacingType;
}>;

export default function SectionArticleSectionArticle({
  children,
  className,
  id,
  gap,
}: Props) {
  if (!gap) {
    gap = "lg";
  }

  const styles: CSSProperties = {
    overflow: "hidden",

    display: "flex",
    flexDirection: "column",
    gap: `var(--spacing-${gap})`,
    padding: "var(--spacing-lg)",

    backgroundColor: "var(--color-background-elevated)",
    borderRadius: "var(--border-radius-sm)",
  };

  return (
    <div className={className} id={id} style={styles}>
      {children}
    </div>
  );
}
